import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangeModeLangService {
  onThemeChange: Subject<{ dir: string; lang: string }> = new Subject();

  constructor() { }

  changeTheme(themePath: string, bootstrapPath: string) {
    this.updateCSS('primeng-theme', themePath);
    this.updateCSS('bootstrap-css', bootstrapPath);
  }

  private updateCSS(id: string, href: string) {
    const linkElement = document.getElementById(id) as HTMLLinkElement;

    if (linkElement) {
      linkElement.href = href;
    } else {
      const newLink = document.createElement('link');
      newLink.id = id;
      newLink.rel = 'stylesheet';
      newLink.href = href;
      document.head.appendChild(newLink);
    }
  }
}
